import React, { useContext } from 'react'
import { ApplicationContext } from 'App/context'

export default () => {
  const appCtx = useContext(ApplicationContext)

  return (
    <div className="logo">
      <img alt={appCtx.name} src={`data:${appCtx.logoMimeType};base64,${appCtx.logoBase64}`} />
      <div className="descr">{appCtx.name}</div>
    </div>
  )
}
